import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.scss'],
})
export class InfoModalComponent implements OnInit {

  @Input() headerIcon: string;
  @Input() headerText: string;
  @Input() bodyText: BodyText[];
  @Input() dismissButtonText: string;

  hideIcon: boolean;

  constructor(private modalCtrl: ModalController) { }

  ngOnInit() {
    this.hideIcon = false;
  }

  async onDismiss() {
    await this.modalCtrl.dismiss();
  }

  setHideIcon(state: boolean) {
    this.hideIcon = state;
  }
}

export interface BodyText {
  text: string;
  class?: string;
}